module.exports = __webpack_public_path__ + "img/m-partner-no.b6c6a15e.webp";